import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController, NavParams } from '@ionic/angular';
import _ from 'lodash';

import { SlackChannel } from 'src/models';
import { AuthService } from 'src/services/auth.service';
import { CollaboratorTypesService } from 'src/services/collaborator-types.service';
import { CustomersService } from 'src/services/customers.service';
import { MessageService } from 'src/services/message.service';
import { SearchablePopoverService } from 'src/services/searchable-popover.service';
import { SlackService } from 'src/services/slack.service';

@Component({
  selector: 'app-edit-collaborator-type',
  templateUrl: './edit-collaborator-type.component.html',
  styleUrls: ['./edit-collaborator-type.component.scss'],
})
export class EditCollaboratorTypeComponent implements OnInit {
  @ViewChild('nameInput', { static: false }) nameInput;

  isLoading = false;
  name: string;
  description: string;
  id?: string;
  key: string;

  constructor(
    navParams: NavParams,
    public authService: AuthService,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private msgSrvc: MessageService,
    private collaboratorTypesService: CollaboratorTypesService,
  ) {
    this.id = navParams.get('id');
  }

  ngOnInit(): void {
    if (this.id) {
      this.loadCollaboratorType();
    } else {
      setTimeout(() => this.nameInput.setFocus(), 500);
    }
  }

  async loadCollaboratorType() {
    try {
      const collaboratorType = await this.collaboratorTypesService.getById(this.id);

      this.name = collaboratorType.name;
      this.description = collaboratorType.description;
      this.key = collaboratorType.key;
    } catch (error) {
      await this.msgSrvc.showError(error);
    }
  }

  async submit() {
    if (!this.name) {
      await this.msgSrvc.show('Whoops! Please enter a name.');

      return;
    }

    this.isLoading = true;

    try {
      if (this.id) {
        await this.collaboratorTypesService.updatePartial(this.id, {
          name: this.name,
          description: this.description,
        });

        await this.msgSrvc.show('Collaborator type updated!');
      } else {
        await this.collaboratorTypesService.create({
          name: this.name,
          description: this.description,
          key: this.generateKey(),
        });

        await this.msgSrvc.show('Collaborator type added!');
      }

      this.dismiss();
    } catch (error) {
      await this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  async delete() {
    const alert = await this.alertCtrl.create({
      header: 'Are you sure?',
      subHeader: `This can't be undone`,
      buttons: [
        {
          text: 'Nevermind',
        },
        {
          text: 'Delete',
          handler: async () => {
            try {
              this.isLoading = true;
              await this.collaboratorTypesService.delete(this.id);
              this.isLoading = false;
              this.dismiss();
            } catch (e) {
              this.isLoading = false;
              this.msgSrvc.show(`Unable to delete collaborator type: ${e}`);
            }
          },
        },
      ],
    });
    alert.present();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  generateKey() {
    return _.snakeCase(this.name);
  }
}
